webpackJsonp([15],{

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("6eeafaa9", content, true);

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, "td[data-v-dca46d5c]{position:relative}img[data-v-dca46d5c]{position:absolute;top:0;width:auto;height:100%;float:left;left:0}button[data-v-dca46d5c]{display:inline-block}.input-group[data-v-dca46d5c]{margin:0}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Team.vue"],"names":[],"mappings":"AACA,oBACE,iBAAmB,CACpB,AACD,qBACE,kBAAmB,AACnB,MAAO,AACP,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,MAAQ,CACT,AACD,wBACE,oBAAsB,CACvB,AACD,8BACE,QAAU,CACX","file":"Team.vue","sourcesContent":["\ntd[data-v-dca46d5c] {\n  position: relative;\n}\nimg[data-v-dca46d5c] {\n  position: absolute;\n  top: 0;\n  width: auto;\n  height: 100%;\n  float: left;\n  left: 0;\n}\nbutton[data-v-dca46d5c] {\n  display: inline-block;\n}\n.input-group[data-v-dca46d5c] {\n  margin: 0;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("27284e0d", content, true);

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, "td .input-group__details{display:none}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Team.vue"],"names":[],"mappings":"AACA,yBACE,YAAc,CACf","file":"Team.vue","sourcesContent":["\ntd .input-group__details {\n  display: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InvitationForm.vue





/* harmony default export */ var InvitationForm = ({
  components: {
    TextInput: inputs["t" /* TextInput */]
  },
  data: function data() {
    return {
      email: '',
      password: '',
      error: {}
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/experts/isLoading'
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    invite: 'skiliko/experts/invite'
  }), {
    submit: function submit() {
      var _this = this;

      this.invite({ email: this.email, password: this.password }).then(function (expert) {
        return _this.$emit('invited', expert);
      }).catch(function (_ref) {
        var response = _ref.response;
        return _this.error = (response || {}).data || {};
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af225384","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvitationForm.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('invitationform.title')))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('invitationform.text')))]),_vm._v(" "),_c('text-input',{attrs:{"config":{
        type: 'email',
        required: true,
        label: _vm.$t('invitationform.labels.email'),
        errors: (_vm.error.email || []).map(function (e) { return function () { return e; }; })
      }},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{
        type: 'password',
        label: _vm.$t('invitationform.labels.password'),
        hint: _vm.$t('invitationform.hints.password'),
        persistentHint: true,
        errors: (_vm.error.password || []).map(function (e) { return function () { return e; }; })
      }},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","ripple":"","loading":_vm.loading}},[_vm._v("\n        "+_vm._s(_vm.$t('invitationform.submit'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_InvitationForm = (esExports);
// CONCATENATED MODULE: ./src/components/InvitationForm.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  InvitationForm,
  components_InvitationForm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_InvitationForm = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Team.vue





/* harmony default export */ var Team = ({
  components: {
    InvitationForm: src_components_InvitationForm
  },
  data: function data() {
    return {
      modal: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    experts: 'skiliko/experts/experts',
    loading: 'skiliko/experts/isLoading'
  }), {
    headers: function headers() {
      var _this = this;

      return ['nickname', 'email', 'role', 'actions'].map(function (h) {
        return {
          text: _this.$t('pages.team.header.' + h),
          sortable: false,
          left: true
        };
      });
    },
    roles: function roles() {
      var _this2 = this;

      return ['restricted', 'active', 'inactive'].map(function (r) {
        return { key: r, title: _this2.$t('pages.team.roles.' + r) };
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetchAll: 'skiliko/experts/fetchAll',
    updateRole: 'skiliko/experts/updateRole',
    updatePriority: 'skiliko/experts/updatePriority'
  }), {
    onInvited: function onInvited(expert) {
      this.modal = false;
    }
  }),
  mounted: function mounted() {
    this.fetchAll();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dca46d5c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Team.vue
var Team_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-dialog',{attrs:{"width":"400","lazy":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('invitation-form',{on:{"invited":function (expert) { return _vm.onInvited(expert); }}})],1),_vm._v(" "),_c('v-btn',{staticClass:"fixed",attrs:{"slot":"activator","floating":"","error":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.modal = true}},slot:"activator"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.$t('pages.team.title'))+"\n  ")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.experts,"loading":_vm.loading,"no-data-text":_vm.$t('pages.team.noDataText'),"no-results-text":_vm.$t('pages.team.noResultsText'),"custom-sort":function (a) { return a; },"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_vm._v("\n      "+_vm._s(props.item.text)+"\n    ")]}},{key:"items",fn:function(props){return [_c('td',[_c('img',{attrs:{"src":props.item.picture.thumb}}),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } }}},[_c('span',{staticClass:"ml-5"},[_vm._v(_vm._s(props.item.nickname))])])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } }}},[_vm._v("\n          "+_vm._s(props.item.email)+"\n        ")])],1),_vm._v(" "),_c('td',[_c('v-select',{attrs:{"value":props.item.role,"items":_vm.roles,"item-text":"title","item-value":"key"},on:{"input":function (role) { return _vm.updateRole({ id: props.item.id, role: role }); }}})],1),_vm._v(" "),_c('td',{attrs:{"width":"200"}},[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.updatePriority({ id: props.item.id, up: true })}}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.updatePriority({ id: props.item.id, up: false })}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"router":"","href":{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } },"icon":""}},[_c('v-icon',[_vm._v("portrait")])],1)],1)]}}])})],1)}
var Team_staticRenderFns = []
var Team_esExports = { render: Team_render, staticRenderFns: Team_staticRenderFns }
/* harmony default export */ var pages_Team = (Team_esExports);
// CONCATENATED MODULE: ./src/pages/Team.vue
function injectStyle (ssrContext) {
  __webpack_require__(953)
  __webpack_require__(955)
}
var Team_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Team___vue_template_functional__ = false
/* styles */
var Team___vue_styles__ = injectStyle
/* scopeId */
var Team___vue_scopeId__ = "data-v-dca46d5c"
/* moduleIdentifier (server only) */
var Team___vue_module_identifier__ = null
var Team_Component = Team_normalizeComponent(
  Team,
  pages_Team,
  Team___vue_template_functional__,
  Team___vue_styles__,
  Team___vue_scopeId__,
  Team___vue_module_identifier__
)

/* harmony default export */ var src_pages_Team = __webpack_exports__["default"] = (Team_Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/15.0db709f8ab89b38ce1a1.js